import styled from 'styled-components';

interface ContainerProps {
  columnsContainerUp?: number;
  columnsContainerDown?: number;
  margin?: string;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
  padding: 0.5rem 0;
  margin: ${({ margin }) => (margin == null ? '0.3rem 0.5rem' : margin)};

  .header {
    display: flex;
    justify-content: space-between;
    padding: 0 1.25rem;

    .header-dados {
      width: 100%;
      margin-right: 1rem;
      display: flex;
      align-items: center;

      .information {
        display: flex;
        flex-direction: column;
        margin-left: 0.6rem;

        .name {
          color: ${({ theme }) => theme.colors.black};
          font-size: 1.2rem;
          font-weight: 400;
        }

        .most-information {
          color: ${({ theme }) => theme.colors.text_gray};
          font-size: 1rem;
        }
        .time {
          display: flex;
          align-items: center;
        }
      }
    }
    @media screen and (max-width: 830px) {
      padding: 0 0.5rem;
    }
  }

  .publication {
    display: flex;
    flex-direction: column;

    .description {
      display: flex;
      margin-top: 0.6rem;
      padding: 0 2rem;

      .description-text {
        display: flex;
        width: 100%;
        word-break: break-word;
        justify-content: flex-start;
        color: ${({ theme }) => theme.colors.black};
        font-family: 'Futura PT' !important;
        font-size: 1.2rem;
      }
    }

    .content {
      width: 90%;
      display: flex;
      justify-content: center;
      align-self: center;
      padding: 1rem 1.5rem;

      .post {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        gap: 0.1rem;

        img {
          display: flex;
          width: 100%;
          height: 100%;
          cursor: pointer;
          border-radius: 0.5rem;
        }

        .containerUp {
          display: grid;
          grid-template-columns: repeat(${({ columnsContainerUp }) => columnsContainerUp}, 1fr);
          gap: 0.1rem;
        }

        .containerDown {
          display: grid;
          grid-template-columns: repeat(${({ columnsContainerDown }) => columnsContainerDown}, 1fr);
          gap: 0.1rem;
          max-height: 15rem;
          justify-items: center;
          position: relative;

          img {
            min-width: 13.5rem;
            max-width: ${({ columnsContainerDown }) =>
              columnsContainerDown === 1 ? '20rem' : '100%'};
            max-height: 13.5rem;
            min-height: 13.5rem;
          }

          .more {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            background: rgb(0 0 0 / 50%);
            border-radius: 0.5rem;
            padding: 0.2rem;
            bottom: 0;
            right: 0;
            width: 13.2rem;
            height: 100%;
            max-height: 13.2rem;
            cursor: pointer;

            p {
              color: ${({ theme }) => theme.colors.background_white};
              font-size: 3rem;
            }
          }
        }
      }
    }
    .location {
      padding: 1rem 1.5rem;
    }
  }

  @media (max-width: 767px) {
    .header .header-dados {
      width: 85%;

      .information {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
`;
